import * as React from "react";
import PropTypes from 'prop-types';

const SvgBirthdayCp = props => {
  if (props.id !== "_svgbirthdaycp") {
    throw new Error('SVG requires <Icon> component as a parent, e.g. <Icon><SvgLogo></Icon>');
  }

  return <svg viewBox="0 0 72 78" fill="none" {...props}><path d="M13.336 32.484h45.046c8.988 0 8.988 4.398 8.988 9.826v8.9c-.01.224-.016.442-.085.645-4.463.31-6.822-5.49-11.313-5.165-3.703.267-5.961 4.974-9.674 5.096-4 .131-6.534-5.12-10.537-5.204-2.246-.046-4.13 1.565-5.91 2.937" stroke="#C00" strokeWidth={1.65} strokeLinecap="round" strokeLinejoin="round" /><path d="M57.901 32.484H12.855c-8.988 0-8.988 4.398-8.988 9.826v8.9c.01.224.016.442.085.645 4.463.31 6.822-5.49 11.313-5.165 3.703.267 5.961 4.974 9.674 5.096 4 .131 6.534-5.12 10.537-5.204 2.246-.046 4.13 1.565 5.91 2.937M31.86 32.484V17.378h6.925V31.49M38.502 23.026l-6.643 4.6M38.502 18.483l-6.643 4.599M38.502 27.885l-6.643 4.599M35.328 10.3v6.89M34.957 1.181s1.82 2.707 2.771 6.035c1.478 5.179-.619 5.395-1.862 6.035" stroke="#C00" strokeWidth={1.65} strokeLinecap="round" strokeLinejoin="round" /><path d="M34.956 13.249s-2.546-.7-2.771-3.66c-.224-2.96 1.41-1.634 2.34-4.594.677-2.157.431-3.816.431-3.816M2.476 71.562c-1.827 0-1.827 4.69 0 4.69h66.93c1.828 0 1.828-4.69 0-4.69H2.476zM6.578 51.418v20.001M65.23 51.871v19.548" stroke="#C00" strokeWidth={1.65} strokeLinecap="round" strokeLinejoin="round" /></svg>;
};

SvgBirthdayCp.displayName = "_svgbirthdaycp";
SvgBirthdayCp.propTypes = {
  id: PropTypes.string
};
SvgBirthdayCp.defaultProps = {
  id: ''
};
export default SvgBirthdayCp;